export enum AuthDialogTypeEnum {
  LOGIN = 'login',
  FORGOT_PASSWORD = 'Forgot Password',
  REGISTER = 'Register',
  LOGIN2PASSWORD = 'login2password',
  LOGIN2SOCIALCONTINUE = 'login2socialcontinue',
}
